module.exports = __webpack_public_path__ + "static/img/deco.d906240.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/common/deco.png
// module id = zlVl
// module chunks = 10